(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 749;
  const TABLET_MIN_WIDTH = 768;
  const TABLET_MAX_WIDTH = 1024;
  const MOBILE_LOAD_MORE_BATCH_SMALL = 4;
  const MOBILE_LOAD_MORE_BATCH_LARGE = 6;
  const MOBILE_LOAD_MORE_CARD_LIMIT = 16;
  const TABLET_LOAD_MORE_BATCH = 18;
  const TABLET_LOAD_MORE_THRESHOLD = 18;
  const DESKTOP_LOAD_MORE_BATCH = 16;
  const DESKTOP_LOAD_MORE_THRESHOLD = 16;
  const swiperInstances = new Map();
  const TAB_STORAGE_PREFIX = 'collection-drop-tab:';
  const NOTIFY_SCROLL_LOCK_NAMESPACE = '.collection-drop-notify';
  let notifyScrollLockCount = 0;
  let notifyScrollPosition = 0;
  let lastViewportWidth = window.innerWidth;

  function lockNotifyScroll() {
    if (notifyScrollLockCount === 0) {
      notifyScrollPosition = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('collection-drop-notify-open', 'lock-scroll');
      document.body.classList.add('collection-drop-notify-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + notifyScrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      if (window.theme && window.theme.a11y && window.theme.a11y.lockMobileScrolling) {
        const scrollContainer = document.querySelector('#MainContent') || document.documentElement;
        window.theme.a11y.lockMobileScrolling(NOTIFY_SCROLL_LOCK_NAMESPACE, scrollContainer);
      }
    }

    notifyScrollLockCount += 1;
  }

  function unlockNotifyScroll() {
    notifyScrollLockCount = Math.max(0, notifyScrollLockCount - 1);
    if (notifyScrollLockCount !== 0) return;

    document.documentElement.classList.remove('collection-drop-notify-open', 'lock-scroll');
    document.body.classList.remove('collection-drop-notify-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, notifyScrollPosition);

    if (window.theme && window.theme.a11y && window.theme.a11y.unlockMobileScrolling) {
      const scrollContainer = document.querySelector('#MainContent') || document.documentElement;
      window.theme.a11y.unlockMobileScrolling(NOTIFY_SCROLL_LOCK_NAMESPACE, scrollContainer);
    }
  }

  function getTabStorageKey() {
    return TAB_STORAGE_PREFIX + window.location.pathname;
  }

  function getSavedTab() {
    try {
      return sessionStorage.getItem(getTabStorageKey());
    } catch (error) {
      return null;
    }
  }

  function saveTab(tab, firstTab) {
    try {
      const storageKey = getTabStorageKey();

      if (tab === firstTab) {
        sessionStorage.removeItem(storageKey);
      } else {
        sessionStorage.setItem(storageKey, tab);
      }
    } catch (error) {
      // sessionStorage may be unavailable in private browsing or restricted contexts
    }
  }

  function isBackForwardNavigation() {
    const navEntry = performance.getEntriesByType('navigation')[0];
    return Boolean(navEntry && navEntry.type === 'back_forward');
  }

  function scrollIfTabsSticky(section) {
    const header = section.querySelector('.collection-drop__header');
    if (!header) return;

    const stickyTop = window.innerWidth <= 1279 ? 88 : 63;
    if (header.getBoundingClientRect().top > stickyTop) return;

    window.scrollTo({
      top: Math.max(0, section.getBoundingClientRect().top + window.scrollY - stickyTop),
      behavior: 'smooth',
    });
  }

  function getGridLoadMoreSettings(gridSection) {
    const grid = gridSection ? gridSection.querySelector('[data-collection-drop-grid]') : null;
    const total = grid ? grid.querySelectorAll('[data-collection-drop-card]').length : 0;
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    if (isMobile) {
      const useLargeMobileBatch = total > MOBILE_LOAD_MORE_CARD_LIMIT;
      const batch = useLargeMobileBatch ? MOBILE_LOAD_MORE_BATCH_LARGE : MOBILE_LOAD_MORE_BATCH_SMALL;

      return {
        isMobile: true,
        initial: batch,
        batch: batch,
        threshold: batch,
        breakpointKey: 'mobile',
      };
    }

    const isTablet = window.innerWidth >= TABLET_MIN_WIDTH && window.innerWidth <= TABLET_MAX_WIDTH;

    if (isTablet) {
      return {
        isMobile: false,
        initial: TABLET_LOAD_MORE_BATCH,
        batch: TABLET_LOAD_MORE_BATCH,
        threshold: TABLET_LOAD_MORE_THRESHOLD,
        breakpointKey: 'tablet',
      };
    }

    return {
      isMobile: false,
      initial: DESKTOP_LOAD_MORE_BATCH,
      batch: DESKTOP_LOAD_MORE_BATCH,
      threshold: DESKTOP_LOAD_MORE_THRESHOLD,
      breakpointKey: 'desktop',
    };
  }

  function updateLoadMoreState(gridSection) {
    const grid = gridSection.querySelector('[data-collection-drop-grid]');
    const loadMoreBtn = gridSection.querySelector('[data-collection-drop-load-more]');
    if (!grid || !loadMoreBtn) return;

    const settings = getGridLoadMoreSettings(gridSection);
    const cards = Array.from(grid.querySelectorAll('[data-collection-drop-card]'));
    const total = cards.length;
    const hiddenCount = cards.filter(function (card) {
      return card.classList.contains('collection-drop__card--load-more-hidden');
    }).length;

    loadMoreBtn.hidden = hiddenCount === 0 || total <= settings.threshold;
  }

  function applyGridVisibility(gridSection) {
    const grid = gridSection.querySelector('[data-collection-drop-grid]');
    if (!grid) return;

    const settings = getGridLoadMoreSettings(gridSection);
    const cards = Array.from(grid.querySelectorAll('[data-collection-drop-card]'));

    cards.forEach(function (card) {
      const index = parseInt(card.getAttribute('data-card-index'), 10) || 0;

      if (index > settings.initial) {
        card.classList.add('collection-drop__card--load-more-hidden');
      } else {
        card.classList.remove('collection-drop__card--load-more-hidden');
      }
    });

    gridSection._lastBreakpointKey = settings.breakpointKey;
    updateLoadMoreState(gridSection);
  }

  function initLoadMoreGrids(section) {
    if (!section) return;

    section.querySelectorAll('.collection-drop__section--mobile-grid').forEach(function (gridSection) {
      const loadMoreBtn = gridSection.querySelector('[data-collection-drop-load-more]');
      if (!loadMoreBtn || loadMoreBtn._loadMoreBound) return;

      loadMoreBtn._loadMoreBound = true;

      loadMoreBtn.addEventListener('click', function () {
        const grid = gridSection.querySelector('[data-collection-drop-grid]');
        if (!grid) return;

        const settings = getGridLoadMoreSettings(gridSection);
        const cards = Array.from(grid.querySelectorAll('[data-collection-drop-card]'));
        const visibleCount = cards.filter(function (card) {
          return !card.classList.contains('collection-drop__card--load-more-hidden');
        }).length;
        const newLimit = visibleCount + settings.batch;

        cards.forEach(function (card) {
          const index = parseInt(card.getAttribute('data-card-index'), 10) || 0;

          if (index <= newLimit) {
            card.classList.remove('collection-drop__card--load-more-hidden');
          }
        });

        updateLoadMoreState(gridSection);
      });

      gridSection._applyGridVisibility = applyGridVisibility.bind(null, gridSection);
      applyGridVisibility(gridSection);
    });
  }

  function refreshLoadMoreGrids(section) {
    if (!section) return;

    section.querySelectorAll('.collection-drop__section--mobile-grid').forEach(function (gridSection) {
      const settings = getGridLoadMoreSettings(gridSection);

      if (gridSection._lastBreakpointKey !== settings.breakpointKey && gridSection._applyGridVisibility) {
        gridSection._applyGridVisibility();
        return;
      }

      updateLoadMoreState(gridSection);
    });
  }

  function updateNoHoverSwapAll() {
    document.querySelectorAll('[data-collection-drop-section]').forEach(function (section) {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        section.classList.add('collection-drop--no-hover-swap');
      } else {
        section.classList.remove('collection-drop--no-hover-swap');
      }
    });
  }

  function destroySwiper(instanceKey) {
    if (!swiperInstances.has(instanceKey)) return;

    const existingSwiper = swiperInstances.get(instanceKey);
    if (existingSwiper && existingSwiper.destroy) {
      existingSwiper.destroy(true, true);
    }

    swiperInstances.delete(instanceKey);
  }

  function initMobileSwiper(swiperElement) {
    if (!swiperElement) return;

    const instanceKey = swiperElement.getAttribute('data-swiper-key') || swiperElement;
    const sectionBlock = swiperElement.closest('.collection-drop__section--mobile-slider');
    const paginationEl = sectionBlock ? sectionBlock.querySelector('.swiper-pagination') : null;

    if (window.innerWidth > MOBILE_BREAKPOINT) {
      destroySwiper(instanceKey);
      return;
    }

    if (swiperInstances.has(instanceKey)) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        initMobileSwiper(swiperElement);
      }, 100);
      return;
    }

    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });

    swiperInstances.set(instanceKey, swiper);
  }

  function initMobileSwipers(section) {
    if (!section) return;

    section.querySelectorAll('[data-collection-drop-swiper]').forEach(function (swiperElement) {
      initMobileSwiper(swiperElement);
    });
  }

  function refreshVisibleSwipers(section) {
    if (!section || window.innerWidth > MOBILE_BREAKPOINT) return;

    const activePanel = section.querySelector('.collection-drop__panel--active:not([hidden])');
    if (!activePanel) return;

    activePanel.querySelectorAll('[data-collection-drop-swiper]').forEach(function (swiperElement) {
      const instanceKey = swiperElement.getAttribute('data-swiper-key') || swiperElement;
      const swiper = swiperInstances.get(instanceKey);

      if (swiper) {
        swiper.update();
      } else {
        initMobileSwiper(swiperElement);
      }
    });
  }

  function initCollectionDrop(section) {
    if (!section) return;

    const tabTriggers = section.querySelectorAll('[data-collection-drop-tab]');
    const tabPanels = section.querySelectorAll('[data-collection-drop-panel]');
    const firstTab = tabTriggers[0] ? tabTriggers[0].getAttribute('data-tab') : null;

    function findTabFromHash(hashValue) {
      const hash = (hashValue || location.hash || '').replace(/^#/, '').toLowerCase();
      if (!hash) return null;

      for (let i = 0; i < tabTriggers.length; i += 1) {
        const triggerButton = tabTriggers[i];
        const slug = (triggerButton.getAttribute('data-tab-label-slug') || '').toLowerCase();
        const handle = (triggerButton.getAttribute('data-tab') || '').toLowerCase();

        if (slug === hash || handle === hash) {
          return triggerButton.getAttribute('data-tab');
        }
      }

      return null;
    }

    function getLabelSlugForTab(tab) {
      for (let i = 0; i < tabTriggers.length; i += 1) {
        const triggerButton = tabTriggers[i];
        if (triggerButton.getAttribute('data-tab') === tab) {
          return triggerButton.getAttribute('data-tab-label-slug') || tab;
        }
      }
      return tab;
    }

    function syncHash(tab) {
      const slug = getLabelSlugForTab(tab);
      if (!slug) return;

      const nextHash = '#' + slug;
      if (location.hash.toLowerCase() === nextHash.toLowerCase()) return;

      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search + nextHash);
      }
    }

    function switchTab(tab, options) {
      const skipSave = options && options.skipSave;
      const skipScroll = options && options.skipScroll;

      tabTriggers.forEach(function (triggerButton) {
        const isActive = triggerButton.getAttribute('data-tab') === tab;
        triggerButton.classList.toggle('collection-drop__tab--active', isActive);
        triggerButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabPanels.forEach(function (panel) {
        const isActive = panel.getAttribute('data-tab') === tab;
        panel.classList.toggle('collection-drop__panel--active', isActive);
        panel.hidden = !isActive;
      });

      if (!skipSave && firstTab) {
        saveTab(tab, firstTab);
      }

      if (!skipScroll) {
        scrollIfTabsSticky(section);
      }

      refreshVisibleSwipers(section);
      refreshLoadMoreGrids(section);
    }

    tabTriggers.forEach(function (triggerButton) {
      triggerButton.addEventListener('click', function () {
        const tab = triggerButton.getAttribute('data-tab');
        if (tab) switchTab(tab);
      });
    });

    const hashTab = findTabFromHash();
    const restoredTab = section.getAttribute('data-tab-restored');

    if (hashTab) {
      switchTab(hashTab, { skipHash: true });
    } else if (restoredTab) {
      refreshVisibleSwipers(section);
      refreshLoadMoreGrids(section);
    } else if (isBackForwardNavigation()) {
      const savedTab = getSavedTab();

      if (savedTab && savedTab !== firstTab) {
        const hasTab = Array.from(tabTriggers).some(function (triggerButton) {
          return triggerButton.getAttribute('data-tab') === savedTab;
        });

        if (hasTab) {
          switchTab(savedTab, { skipSave: true, skipScroll: true });
        }
      }
    }

    if (!section._hashChangeBound) {
      section._hashChangeBound = true;
      window.addEventListener('hashchange', function () {
        const tabFromHash = findTabFromHash();
        if (tabFromHash) {
          switchTab(tabFromHash, { skipHash: true });
        }
      });
    }

    section.querySelectorAll('.collection-drop__card-arrow--prev, .collection-drop__card-arrow--next').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const card = button.closest('.collection-drop__card');
        if (card) card.classList.toggle('collection-drop__card--showing-secondary');
      });
    });

    updateNoHoverSwapAll();
    initMobileSwipers(section);
    initLoadMoreGrids(section);
    initNotifyModal(section);
  }

  function initNotifyModal(section) {
    const modal = section.querySelector('[data-collection-drop-notify-modal]');
    if (!modal) return;

    const badgeEl = modal.querySelector('[data-collection-drop-notify-badge]');
    const titleEl = modal.querySelector('[data-collection-drop-notify-title]');

    function openModal(badge, title) {
      if (badgeEl) badgeEl.textContent = badge;
      if (titleEl) titleEl.textContent = title;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      lockNotifyScroll();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      unlockNotifyScroll();
    }

    modal.addEventListener(
      'touchmove',
      function (event) {
        if (modal.hidden) return;

        const dialog = modal.querySelector('.collection-drop__notify-dialog');
        if (dialog && dialog.contains(event.target)) return;

        event.preventDefault();
      },
      { passive: false }
    );

    function handleNotifyTrigger(trigger) {
      openModal(trigger.getAttribute('data-notify-badge') || '', trigger.getAttribute('data-notify-title') || '');
    }

    section.querySelectorAll('[data-collection-drop-notify]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        handleNotifyTrigger(button);
      });
    });

    section.querySelectorAll('.collection-drop__card-link--notify, .collection-drop__card-title-link--notify').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        handleNotifyTrigger(link);
      });
    });

    modal.querySelectorAll('[data-collection-drop-notify-close]').forEach(function (closeTrigger) {
      closeTrigger.addEventListener('click', closeModal);
    });

    const notifyForm = modal.querySelector('[data-collection-drop-notify-form]');
    if (notifyForm) {
      notifyForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const emailInput = notifyForm.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value.trim()) {
          emailInput && emailInput.focus();
          return;
        }
      });
    }

    modal._closeNotifyModal = closeModal;
  }

  function handleEscapeKey(event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-collection-drop-notify-modal]:not([hidden])').forEach(function (modal) {
      if (modal._closeNotifyModal) modal._closeNotifyModal();
    });
  }

  function handleResize() {
    const currentWidth = window.innerWidth;
    const wasMobile = lastViewportWidth <= MOBILE_BREAKPOINT;
    const isMobile = currentWidth <= MOBILE_BREAKPOINT;
    const crossedBreakpoint = wasMobile !== isMobile;

    lastViewportWidth = currentWidth;
    updateNoHoverSwapAll();

    document.querySelectorAll('[data-collection-drop-section]').forEach(function (section) {
      if (crossedBreakpoint) {
        section.querySelectorAll('[data-collection-drop-swiper]').forEach(function (swiperElement) {
          const instanceKey = swiperElement.getAttribute('data-swiper-key') || swiperElement;

          destroySwiper(instanceKey);
          if (isMobile) initMobileSwiper(swiperElement);
        });
      }

      refreshLoadMoreGrids(section);
    });
  }

  document.addEventListener('keydown', handleEscapeKey);

  function initAll() {
    document.querySelectorAll('[data-collection-drop-section]').forEach(initCollectionDrop);
  }

  window.addEventListener('resize', handleResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;

    const section = document.querySelector('[data-collection-drop-section][data-section-id="' + sectionId + '"]');
    if (section) initCollectionDrop(section);
  });
})();
